<template>
  <div>
    <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-container class="px-10 pt-8">
          <v-form v-model="isFormValid">
            <p class="subtitle-1 font-weight-bold mb-2">Reject Refund</p>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="4">
                <p class="caption">Tenant:</p>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="8">
                <p class="caption font-weight-bold">{{ tenantName }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="4">
                <p class="caption">Unit:</p>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="8">
                <p class="caption font-weight-bold">{{ unitName }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="4">
                <p class="caption">Amount:</p>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="8">
                <p class="caption font-weight-bold">
                  {{ formatCurrency(amount) }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="4">
                <p class="caption">Refundable Amount:</p>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="8">
                <p class="caption font-weight-bold">
                  {{ formatCurrency(maxAmount) }}
                </p>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="12">
                <v-textarea
                  v-model="reason"
                  name="reason"
                  label="Reason"
                  prepend-inner-icon="mdi-information"
                  dense
                  outlined
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="primary darken-1"
              text
              :disabled="!isFormValid"
              @click="finish"
              >Finish</v-btn
            >
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getUsableAmount } from '../../util/securityDeposit'
import { formatCurrency } from '../../util/currency'

export default {
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      tenantName: '',
      maxAmount: 0,
      amount: 0,
      reason: '',
      unitName: '',
      isFormValid: false,
      formatCurrency
    }
  },
  methods: {
    open(securityDeposit) {
      this.dialog = true
      this.tenantName = securityDeposit.tenantName
      this.maxAmount = getUsableAmount(securityDeposit)
      this.amount = securityDeposit.amount
      this.unitName = securityDeposit.unitName
      this.securityDepositId = securityDeposit.securityDepositId
      this.reason = ''
    },
    async finish() {
      const confirm = await this.$root.$confirm({
        title: 'Reject Refund',
        message: 'Are you sure you want to reject the refund?'
      })

      if (confirm) {
        this.$root.$setLoading(true)
        try {
          await this.$store.dispatch('securityDeposits/rejectRefund', {
            securityDepositId: this.securityDepositId,
            reason: this.reason
          })

          this.dialog = false
          this.$root.$setLoading(false)
          await this.$root.$confirm({
            title: 'Reject Refund',
            message: `The refund has been rejected.`,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'success'
            }
          })
          this.$emit('reload')
        } catch (err) {
          await this.$root.$confirm({
            title: 'Reject Refund',
            message: err.message,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'error'
            }
          })
          this.$emit('reload')
        }
      }
    },
    cancel() {
      this.dialog = false
    }
  }
}
</script>
